import { useQuery } from '@tanstack/react-query';

import get from '../services/logo-service';

const useOrgUnitLogo = (): string | null => {
  const activationCode = sessionStorage.getItem('gezondleven-activation-code');

  const { data } = useQuery(['orgunit-logo', activationCode], () => get(activationCode ?? null), {
    staleTime: undefined,
  });

  return data?.imageUrl ?? null;
};

export default useOrgUnitLogo;
